import { Button } from '@material-ui/core';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { ResetPasswordContainer } from '../reset-password';
import { MatField } from 'src/core/components/mat-field';
import { PageError } from 'src/core/components/page-error/page-error';

const passwordErrorMap = {
    required: 'This field is required.',
    length: 'The password needs to be longer.',
    needsLetter: 'You’re missing a letter.',
    needsNumber: 'You’re missing a number.',
    noMatch: 'Oops, that’s not the same password as the first one.',
};

interface Props {
    container: ResetPasswordContainer;
}

export const ResetPassword = observer<React.SFC<Props>>(({ container: { data } }) => (
    <div className="page page-inverted login-image-background">
        <div className="page-topping">
            <PageError absolute message={data.errorMessage} onClose={data.clearError} />
        </div>

        <div className="card">
            <form className="flex-form" onSubmit={data.handleSubmit}>
                <h1>Reset your password</h1>
                {data.step === 1 ? (
                    <p>
                        Your password must be at least 8 characters long. Make sure to use 1 letter
                        and 1 number.
                    </p>
                ) : (
                    <p>Please confirm your password, we’re just being extra safe.</p>
                )}
                <div className={classnames('form-field', 'single-input')}>
                    <MatField
                        fullWidth
                        type={data.showPassword ? 'text' : 'password'}
                        autoFocus
                        label={data.step === 1 ? 'New password' : 'Confirm password'}
                        fieldState={data.password}
                        errorMap={passwordErrorMap}
                        disabled={data.form.hasFormError}
                        autoComplete="new-password"
                        endAdornment={
                            <a onClick={data.toggleShowPassord}>
                                {data.showPassword ? 'Hide' : 'Show'}
                            </a>
                        }
                    />
                </div>
                <div className="space-filler" />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="next-step-button"
                    disabled={data.form.hasError}
                >
                    {data.step === 1 ? 'Continue' : 'Submit'}
                </Button>
            </form>
        </div>
    </div>
));
